import Button from "../ui/Button";
import { Settings } from "lucide-react";
import LeadScoreCard from "../leads/LeadScoreCard";
import ChatboxSettingsCard from "./ChatboxSettingsCard";
import Accordion from "../ui/Accordion";

import { useAuthStore } from "../../store/authStore";

export default function AgentConfigurations({
  openLeadScoreModal,
  openChatboxModal,
  onOpenSettings,
  agentDetails,
}) {
  const { user } = useAuthStore();
  const isAgent = user?.role === "agent";

  if(isAgent){
    return null;
  }

  return (
    <Accordion
      title="Configurations"
      className="accordion-section agent-config-cont"
      actions={
        <Button variant="plain" onClick={onOpenSettings}>
          <Settings size={33} />
        </Button>
      }
    >
      <section className="agent-config-grid">
        <LeadScoreCard
          onEdit={openLeadScoreModal}
          scoringConfig={agentDetails?.scoring_config}
        />
        <ChatboxSettingsCard
          onEdit={openChatboxModal}
          chatboxSettings={agentDetails?.settings}
        />
      </section>
    </Accordion>
  );
}